/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Criticality } from './Criticality';
import type { IncidentDatasetDto } from './IncidentDatasetDto';
import type { IncidentTeamDto } from './IncidentTeamDto';
import type { UserDto } from './UserDto';

export type DataProductUpstreamIncidentDto = {
    accessAuthorized: boolean;
    assignees: Array<UserDto>;
    associatedDomainNames?: Array<string> | null;
    compromisedAssets: number;
    criticality: Criticality;
    datasets: Array<IncidentDatasetDto>;
    id: string;
    issueNo: number;
    lastOccurredDate: number;
    name: string;
    status: DataProductUpstreamIncidentDto.status;
    teams: Array<IncidentTeamDto>;
};

export namespace DataProductUpstreamIncidentDto {

    export enum status {
        OPEN = 'OPEN',
        IN_PROGRESS = 'IN_PROGRESS',
        CLOSED = 'CLOSED',
    }


}
